import { jsx as t } from "react/jsx-runtime";
import { useTheme as e } from "@mui/joy";
const r = (r2) => {
  const n = e(), { x: l, y: o, payload: i } = r2, a = function(t2, e2 = 10) {
    if (null == t2) return "";
    const r3 = String(t2);
    if (r3.length <= e2) return r3;
    const n2 = Math.floor((e2 - 3) / 2);
    return r3.slice(0, n2) + "..." + r3.slice(r3.length - n2);
  }(i.value, 10);
  return t("text", { x: l, y: o, textAnchor: "end", fontSize: 12, fill: n.palette.isDarkMode ? n.palette.neutral[600] : n.palette.neutral[400], children: a });
};
export {
  r as CustomXAxisTick
};
//# sourceMappingURL=CustomXAxisTick.js.map
